export const deepLinkRoutes = Object.freeze({
	ForgotPassword: '/forgot-password',
	VerifyEmail: '/verify-email',
	AllowSender: '/allow-sender',
	BlockSender: '/block-sender',
	Filter: '/filter',
	Mails: '/mails',
	DeliverMail: '/deliver-mail',
	LockrArchive: '/lockrscan/archive'
})